package team.platforma.chat_data

import app.cash.sqldelight.async.coroutines.awaitCreate
import app.cash.sqldelight.driver.worker.WebWorkerDriver
import org.w3c.dom.Worker
import team.platforma.chatdata.database.ChatDatabase

actual class ChatDBFactory actual constructor() {
    actual suspend fun web(): ChatDatabase? {
        val driver = WebWorkerDriver(
            Worker(
                js("""new URL("@cashapp/sqldelight-sqljs-worker/sqljs.worker.js", import.meta.url)""")
            )
        )
        ChatDatabase.Schema.awaitCreate(driver)
        return ChatDatabase(driver)
    }
}